import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { TransactionAmount } from "@components/transactions/TransactionAmount";
import { EmptyCell } from "@components/history/views/cells/EmptyCell";
import styles from "./HistoryDetailsCells.module.scss";
import { HistoryDetailsBaseRow } from "./historyDetailsBaseRow";

interface HistoryDetailsAmountCellProps {
    row: {
        original: HistoryDetailsBaseRow & {
            resource?: Record<string, unknown>;
            amount?: number;
            originalAmount?: number;
        };
    };
}

export const HistoryDetailsAmountCell = memo(
    ({ row }: HistoryDetailsAmountCellProps) => {
        const { resource, amount, originalAmount } = row.original;
        if (!resource && !amount && !originalAmount) {
            return (
                <ViewTableCell className={styles.amount}>
                    <EmptyCell />
                </ViewTableCell>
            );
        }

        const amountValue = amount ?? resource?.amount;
        const originalAmountValue = originalAmount ?? resource?.originalAmount;

        // null or undefined
        if (amountValue == null || originalAmountValue == null) {
            return (
                <ViewTableCell className={styles.amount}>
                    <EmptyCell />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell className={styles.amount}>
                <TransactionAmount
                    transaction={{
                        amount: amountValue as number,
                        originalAmount: originalAmountValue as number,
                    }}
                    color
                    addSign
                    className={styles.amount}
                />
            </ViewTableCell>
        );
    },
);

HistoryDetailsAmountCell.displayName = "HistoryDetailsAmountCell";
